import { FC } from 'react';
import {
  AxisChart,
  ChartBase,
  AxisChartByDate,
  AxisChartByNumberPrediction,
  AxisChartByString,
  ChartByStringBarScatter,
  ChartDataType,
  ChartDisplayType
} from '../chart.models';
import ChartTypeButton from '../chartButtons/chartTypeButton';
import { ChartStrategyDate } from './chart-strategy-date';
import { ChartStrategyString } from './chart-strategy-string';
import { RangeRouteWeek } from '../chartButtons/constants/RangeRoutes';
import ChartDateRangeButton from '../chartButtons/chartDateRangeButton';
import { ChartStrategyNumberPrediction } from './chart-strategy-number-prediction';
import { ChartStrategyStringBarScatter } from './chart-strategy-string-bar-scatter';

const defaultDateRange = RangeRouteWeek;

export const ChartBridge: FC<{
  chart: ChartBase;
}> = ({ chart }: { chart: ChartBase }) => {
  const chartStrategy = () => {
    switch (chart.type) {
      case ChartDataType.DATE:
        return <ChartStrategyDate chart={chart as AxisChartByDate} />;
      case ChartDataType.STRING:
        return <ChartStrategyString chart={chart as AxisChartByString} />;
      case ChartDataType.STRING_BAR_SCATTER:
        return (
          <ChartStrategyStringBarScatter
            chart={chart as ChartByStringBarScatter}
          />
        );
      case ChartDataType.NUMBER_PREDICTION:
        return (
          <ChartStrategyNumberPrediction
            chart={chart as AxisChartByNumberPrediction}
          />
        );
      default:
        throw Error(
          `Unexpected ChartDataType when trying to bridge to strategy: ${chart.type}`
        );
    }
  };

  const basicChart = chart as AxisChart;
  const shouldShowChartTypeDropdown = basicChart.shouldShowChartTypeDropdown;

  const shouldShowDateRangeDropdown =
    chart.type === ChartDataType.DATE &&
    (chart as AxisChartByDate).shouldShowDateRangeDropdown;

  return (
    <>
      {shouldShowChartTypeDropdown || shouldShowDateRangeDropdown ? (
        <>
          <div className="flex flex-row min-w-fit space-x-2 w-32 pb-2">
            {shouldShowChartTypeDropdown ? (
              <ChartTypeButton
                chartId={chart.id}
                defaultType={ChartDisplayType.STACKED_BAR}
              />
            ) : null}
            {shouldShowDateRangeDropdown ? (
              <ChartDateRangeButton
                chartId={chart.id}
                defaultRange={defaultDateRange.key}
              />
            ) : null}
          </div>
        </>
      ) : null}
      {chartStrategy()}
    </>
  );
};

export default ChartBridge;
